import { render, staticRenderFns } from "./AIChatComponent.vue?vue&type=template&id=728e1435"
import script from "./AIChatComponent.vue?vue&type=script&lang=js"
export * from "./AIChatComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports